import React from 'react';
import ManagePaymentMethodsPageView from 'components/payments/ManagePaymentMethodsPageView';
import commonStyles from 'styles/common.module.scss';

const StandalonePaymentMethodsPage: React.FunctionComponent = () => {
  return (
    <>
      <h1 className={commonStyles.pageTitle}>Saved Payment Methods</h1>
      <ManagePaymentMethodsPageView />
    </>
  );
};

export default StandalonePaymentMethodsPage;
